import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import useUserStuff from "./useUserStuff";

const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();
    const  {userStuff} = useUserStuff();

    useEffect(() => {
        // Request interceptor
        const requestInterceptor = axiosPrivate.interceptors.request.use(
            (config) => {
                if (!config.headers['Authorization']) {
                    if(!auth?.accessToken === undefined || !auth?.accessToken === null){
                        config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                    }
                        config.headers['Authorization'] = `Bearer ${localStorage.getItem('refreshToken')||userStuff?.refreshToken}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Response interceptor
        const responseInterceptor = axiosPrivate.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error?.response?.status === 403) {
                    const prevRequest = error?.config;
                    if (prevRequest && !prevRequest?.sent) {
                        prevRequest.sent = true;
                        try {
                            const newAccessToken = await refresh();
                            prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                            return axiosPrivate(prevRequest);
                        } catch (refreshError) {
                            return Promise.reject(refreshError);
                        }
                    }
                }
                return Promise.reject(error);
            }
        );

        // Clean up interceptors
        return () => {
            if (requestInterceptor) {
                axiosPrivate.interceptors.request.eject(requestInterceptor);
            }
            if (responseInterceptor) {
                axiosPrivate.interceptors.response.eject(responseInterceptor);
            }
        };
    }, [auth, refresh]);

    return axiosPrivate;
};

export default useAxiosPrivate;
